import AttachmentClass from 'lib/project/classes/Attachment';

export default {
  data() {
    return {
      submittingDisabled: false,
      attachment: new AttachmentClass,
    };
  },
  methods: {
    onImageLoading(value) {
      this.submittingDisabled = value;
    },
  },
};
